<template>
    <div class="container admin-table-page">
        <!-- Fila del título y flecha hacia atrás -->
        <div class="param-title-wrap niif-header">
            <div class="d-flex align-items-center w-100">
                <div class="d-flex align-items-center">
                    <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                        <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" class="back-icon" />
                    </b-button>
                    <h2 class="param-title">{{ labels.title }}</h2>
                </div>
            </div>
        </div>
        <!-- Fila de filtros debajo del título a la izquierda -->
        <div class="param-title-wrap niif-header">
            <div class="d-flex align-items-center w-100">
                <div class="filters-container d-flex align-items-center">
                    <b-form-select
                        id="report-select"
                        v-model="fecha"
                        class="filter-select"
                    >
                        <b-form-select-option value="">
                            {{ labels.selectReport }}
                        </b-form-select-option>
                        <option v-for="item in lstFechaCierre" :key="item.id" :value="item.fecha_cierre">
                            {{ item.fecha_cierre }}
                        </option>
                    </b-form-select>                  
                    <b-button
                        class="consult-btn ml-2"
                        @click="consulReporSaldPorCierre()"
                        :disabled="!fecha"
                    >
                        <font-awesome-icon :icon="['fas', 'search']" class="mr-1" />
                        {{ labels.consultar }}
                  </b-button>
                </div>
            </div>
        </div>
        <div class="admin-table-block mt-4">
            <div v-if="!isLoading">
                <CorporateDataTable
                :items="lstReporSaldCierre"
                :fields="allFields"
                :labels="tableLabels"
                :default-per-page="10"
                :page-options="[10, 20, 50, 100]"
                :narrow="false"
                :table-min-height="500"
                :table-max-height="500"
                :show-search="showSearchTable"
                :allow-column-toggle="true"
                :enable-sorting="true"
                :filter-defs="tableFilterDefs"
                :toolbar-disabled="!showToolbarExtras"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right">
                            <b-button
                            size="sm"
                            class="table-toolbar-excel-btn"
                            @click="genReportSaldCierre()"
                            :disabled="!showToolbarExtras || lstReporSaldCierre.length === 0"
                            >
                            <font-awesome-icon :icon="['fas', 'file-excel']" class="mr-1" />
                            </b-button>
                        </div>
                    </template>
                    <template #cell(activo_derecho_uso)="data">
                        <div class="text-right">{{ formatNumber(data.item?.activo_derecho_uso) }}</div> 
                    </template>
                    <template #cell(pasivo_final)="data">
                        <div class="text-right">{{ formatNumber(data.item?.pasivo_final) }}</div> 
                    </template>
                    <template #cell(patrimonio_neto)="data">
                        <div class="text-right">{{ formatNumber(data.item?.patrimonio_neto) }}</div> 
                    </template>
                    <template #cell(pasivo_inicial)="data">
                        <div class="text-right">{{ formatNumber(data.item?.pasivo_inicial) }}</div> 
                    </template>
                    <template #cell(pago_capital)="data">
                        <div class="text-right">{{ formatNumber(data.item?.pago_capital) }}</div> 
                    </template>
                    <template #cell(gasto_por_amortizacion)="data">
                        <div class="text-right">{{ formatNumber(data.item?.gasto_por_amortizacion) }}</div> 
                    </template>
                    <template #cell(gasto_por_intereses)="data">
                        <div class="text-right">{{ formatNumber(data.item?.gasto_por_intereses) }}</div> 
                    </template>
                    <template #cell(gasto_canon)="data">
                        <div class="text-right">{{ formatNumber(data.item?.gasto_canon) }}</div> 
                    </template>
                </CorporateDataTable>
            </div>

            <!-- Spinner de carga -->
            <div v-if="isLoading" class="text-center py-5">
                <b-spinner></b-spinner>
                <p class="mt-2">{{ labels.loading }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import ContratoCierre from '../../services/ContratoCierre'; 
import Reportes from '../../services/Reportes'; 
import Authentication from "../../services/Authentication" 
import * as XLSX from "exceljs";
import CorporateDataTable from '../utils/CorporateDataTable.vue';

export default {
    name : 'SaldosPorCierre',
    components : {CorporateDataTable},
    data : () => ({
        fecha : '',
        nameCompania : '',
        lstReporSaldCierre : [],
        lstFechaCierre : [],
        btnGenExcel : false,
        isLoading : false,
        showToolbarExtras: false
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Reporte saldos por cierre',
                    fecha : 'Fecha cierre',
                    consultar : 'Consultar',
                    seleccion : 'Seleccione...',
                    contrato : 'Contrato', 
                    arrendador : 'Arrendador',
                    actiDerUsoBrt : 'Activo derecho uso bruto',
                    pasivoFin : 'Pasivo final',
                    patrimNeto : 'Patrimonio neto',
                    pasivoInicial : 'Pasivo inicial',
                    pagoCap : 'Pago capital',
                    gastoAmort : 'Gasto por amortización',
                    gastoInter : 'Gasto por intereses',
                    gastArrendam : 'Gasto por arrendamiento',
                    selectReport : 'Seleccione Fecha', 
                    loading: 'Cargando...',
                    noData: 'No hay datos disponibles',
                    noMatches: 'No se encontraron resultados',
                    searchPlaceholder: 'Buscar en la tabla...',
                    rowsPerPage: 'Filas por página:',
                    noSort: 'Sin orden',
                    sortAsc: 'A-Z / Menor a mayor',
                    sortDesc: 'Z-A / Mayor a menor',
                    columns: 'Columnas',
                    showAllColumns: 'Mostrar todas',
                    filters: 'Filtros',
                    clearFilters: 'Limpiar filtros',
                    filterContrato : 'Filtrar contrato...',
                    filterArrendador : 'Filtrar arrendador...',
                    filterActDerUsoBrt : 'Filtrar activo derecho uso bruto...',
                    filterPasivFinal : 'Filtrar pasivo final...',
                    filterPatNeto : 'Filtrar patrimonio neto...',
                    filterPasivoIni : 'Filtrar pasivo inicial...',
                    filterPagCapital : 'Filtrar pago capital...',
                    filterGastoAmort : 'Filtrar gasto por amortización...',
                    filterGastoInter : 'Filtrar gasto por intereses...',
                    filterGastArrent : 'Filtrar gasto por arrendamiento...',
                }
            }else{
                return {
                    title : 'Closing balance report',
                    fecha : 'Closing date',
                    consultar : 'Consult',
                    seleccion : 'Select...',
                    selectReport : 'Select Date',
                    loading: 'Loading...', 
                    noData: 'No data available',
                    noMatches: 'No results found',
                    searchPlaceholder: 'Search in table...',
                    rowsPerPage: 'Rows per page:',
                    noSort: 'No sorting',
                    sortAsc: 'A-Z / Low to high',
                    sortDesc: 'Z-A / High to low',
                    columns: 'Columns',
                    showAllColumns: 'Show all',
                    filters: 'Filters',
                    clearFilters: 'Clear filters',
                    contrato : 'Contract', 
                    arrendador : 'Lessor',
                    actiDerUsoBrt : 'Asset right gross use',
                    pasivoFin : 'Final passive',
                    patrimNeto : 'Net worth',
                    pasivoInicial : 'Opening liabilities',
                    pagoCap : 'Principal payment',
                    gastoAmort : 'Amortization expense',
                    gastoInter : 'Gasto por intereses',
                    gastArrendam : 'Lease expense',
                    filterContrato : 'Filter contract...',
                    filterArrendador : 'Filter landlord...',
                    filterActDerUsoBrt : 'Filter active gross right-of-use...',
                    filterPasivFinal : 'Filter final passive...',
                    filterPatNeto : 'Filter net worth...',
                    filterPasivoIni : 'Filter initial passive...',
                    filterPagCapital : 'Filter principal payment...',
                    filterGastoAmort : 'Filter amortization expense...',
                    filterGastoInter : 'Filter interest expense...',
                    filterGastArrent : 'Filter lease expenses...',
                }
            }
        },
        allFields() {
            return [
                { key: 'nro_contrato', label: this.labels.contrato, sortable: true, thClass: 'text-center', tdClass: 'text-center align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '100px' } },
                { key: 'arrendador', label: this.labels.arrendador, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '300px' } } ,
                { key: 'activo_derecho_uso', label: this.labels.actiDerUsoBrt, sortable: true, thClass: 'text-left', tdClass: 'text-end align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '100px' } },
                { key: 'pasivo_final', label: this.labels.pasivoFin, sortable: true, thClass: 'text-left', tdClass: 'text-end align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '150px' } },
                { key: 'patrimonio_neto', label: this.labels.patrimNeto, sortable: true, thClass: 'text-left', tdClass: 'text-end align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '150px' } },
                { key: 'pasivo_inicial', label: this.labels.pasivoInicial, thClass: 'text-center', tdClass: 'text-end align-middle', sortable: false, thStyle: { whiteSpace: 'nowrap', minWidth: '150px' } },
                { key: 'pago_capital', label: this.labels.pagoCap, thClass: 'text-center', tdClass: 'text-end align-middle', sortable: false, thStyle: { whiteSpace: 'nowrap', minWidth: '150px' } },
                { key: 'gasto_por_amortizacion', label: this.labels.gastoAmort, sortable: true, thClass: 'text-center', tdClass: 'text-end align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '100px' } },
                { key: 'gasto_por_intereses', label: this.labels.gastoInter, sortable: true, thClass: 'text-left', tdClass: 'text-end align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '100px' } },
                { key: 'gasto_canon', label: this.labels.gastArrendam, thClass: 'text-center', tdClass: 'text-end align-middle', sortable: false, thStyle: { whiteSpace: 'nowrap', minWidth: '100px' } }
            ]
        },
        tableFilterDefs() {
            return [
                { key: 'descripcion', type: 'text', placeholder: this.labels.filterContrato },
                { key: 'arrendador', type: 'text', placeholder: this.labels.filterArrendador },
                { key: 'activo_derecho_uso', type: 'text', placeholder: this.labels.filterActDerUsoBrt },
                { key: 'pasivo_final', type: 'text', placeholder: this.labels.filterPasivFinal },
                { key: 'patrimonio_neto', type: 'text', placeholder: this.labels.filterPatNeto },
                { key: 'pasivo_inicial', type: 'text', placeholder: this.labels.filterPasivoIni },
                { key: 'pago_capital', type: 'text', placeholder: this.labels.filterPagCapital },
                { key: 'gasto_por_amortizacion', type: 'text', placeholder: this.labels.filterGastoAmort },
                { key: 'gasto_por_intereses', type: 'text', placeholder: this.labels.filterGastoInter },
                { key: 'gasto_canon', type: 'text', placeholder: this.labels.filterGastArrent }
            ]
        },
        tableLabels() {
            return {
                noRow: this.labels.noData,
                noMatches: this.labels.noMatches,
                searchPlaceholder: this.labels.searchPlaceholder,
                rowsPerPage: this.labels.rowsPerPage,
                noSort: this.labels.noSort,
                sortAsc: this.labels.sortAsc,
                sortDesc: this.labels.sortDesc,
                columns: this.labels.columns,
                showAllColumns: this.labels.showAllColumns,
                filters: this.labels.filters,
                clearFilters: this.labels.clearFilters
            }
        },
        showSearchTable() {
            return true
        }
    },
    methods:{
        goBack() {
            this.$router.back()
        },
        formatNumber(value) {
            return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 })?.format(value); 
        },
        async consulReporSaldPorCierre(){

            if (!this.fecha) return;

            this.isLoading = true;

            try {
                const res = await Reportes.generaReporteSaldosPorCierre(this.fecha);

                this.lstReporSaldCierre = res.data.lstReporSaldPorCierre || [];

                this.showToolbarExtras = this.lstReporSaldCierre.length > 0;

                if (!this.lstReporSaldCierre.length) {
                    this.$toast.error("No hay datos para la fecha seleccionada.");
                }

            } catch (error) {
                console.error('Error en consultarReporte:', error);
                this.lstReporSaldCierre = [];
                this.showToolbarExtras = false;
            
            } finally {
                this.isLoading = false;
            }
        },
        async genReportSaldCierre(){
            
            const {Workbook} = XLSX
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet("Saldos por cierre "+this.fecha) 

            const titulo = ["Saldos por cierre "+this.fecha] 
            worksheet.addRow(titulo) 
            worksheet.mergeCells('A1:J1') 
            worksheet.getCell('A1').font = { name: 'Arial', bold : true, size : 12}; 
            worksheet.getCell('A1').alignment = { horizontal : 'center'}; 

            // =======================
            // FILA 2
            // =======================
            worksheet.addRow(['']); 
            worksheet.mergeCells('A2:J2'); 

            const cell2 = worksheet.getCell('A2'); 

            cell2.value = { 
                richText: [
                    { text: 'Generado por: ', font: { bold: true } },
                    { text: `${this.$store.state.userName} | ` }, 

                    { text: 'Fecha generación: ', font: { bold: true } },
                    { text: `${this.fechaActual()} | ` }, 

                    { text: 'Compañía: ', font: { bold: true } },
                    { text: `${this.nameCompania}` }, 
                ]
            };

            cell2.font = { name: 'Arial', size: 12 }; 
            cell2.alignment = { horizontal: 'center', vertical: 'middle' }; 

            worksheet.addRow(['']); 
            worksheet.mergeCells('A3:J3') 

            const tituloCelda = [
                'Contrato',
                'Arrendador',
                'Activo derecho de uso',
                'Pasivo final',
                'Patrimonio neto',
                'Pasivo inicial',
                'Pago capital',
                'Gasto por amortización',
                'Gasto por intereses',
                'Gasto por arrendamiento'
            ]

            const headerRow = worksheet.addRow(tituloCelda) 
            headerRow.font = { name: 'Arial', bold: true, size: 12 }; 
            headerRow.alignment = { horizontal: 'center' } 

            this.lstReporSaldCierre.map((e) => { 
                worksheet.addRow([ 
                    e.nro_contrato, 
                    e.arrendador, 
                    this.formatNumber(e.activo_derecho_uso), 
                    this.formatNumber(e.pasivo_final), 
                    this.formatNumber(e.patrimonio_neto), 
                    this.formatNumber(e.pasivo_inicial), 
                    this.formatNumber(e.pago_capital), 
                    this.formatNumber(e.gasto_por_amortizacion), 
                    this.formatNumber(e.gasto_por_intereses), 
                    this.formatNumber(e.gasto_canon) 
                ])
            })

            //Poner borde
            const border = {
                top : {style : 'thin'},
                left : {style : 'thin'},
                bottom : {style : 'thin'},
                right : {style : 'thin'},
            }

            for( let row = 1; row <= worksheet.rowCount; row++){ 
                if ([1, 2, 3].includes(row)) continue; // omitir filas 
                for( let col = 1; col <= worksheet.columnCount; col++){ 
                    worksheet.getCell(row, col).border = border; 
                }
            }
            //------

            const file = await workbook.xlsx.writeBuffer() 
            const downloadLink = document.createElement("a") 
            downloadLink.download = "Reporte saldos por cierre.xlsx" 
            downloadLink.href = window.URL.createObjectURL( 
                new Blob([file], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 
                })
            )

            downloadLink.style.display = "none"; 

            document.body.appendChild(downloadLink); 
            downloadLink.click(); 

            downloadLink.remove(); 
        },
        fechaActual(){
            const fecha = new Date()

            const año = fecha.getFullYear() 
            const mes = String(fecha.getMonth() + 1).padStart(2, '0') // getMonth() va de 0 a 11 
            const dia = String(fecha.getDate()).padStart(2, '0') 

            return `${año}-${mes}-${dia}`
        },
    },
    mounted(){
        ContratoCierre.getListadoFechas() 
        .then((res) => { 
            // console.log(res.data.lstFechaCierre); 
            this.lstFechaCierre = res.data.lstFechaCierre 
        })
        .catch((err) => console.log(err)) 

        Authentication.leaParametros() 
        .then ((result) => { 
            this.nameCompania = result.data.parametros.compania 
        })
        .catch((err) => console.log(err)) 
    },
    watch:{
        fecha(val){
            if(val == ""){
                this.lstReporSaldCierre = [] 
                this.showToolbarExtras = false;
            }
        }
    }
}
</script>

<style src="../main.css"> 
</style>
<style scoped>
/* Estilos para el contenedor de filtros - ahora a la izquierda */
.niif-header .filters-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    margin-left: 0 !important;
}

.niif-header .filter-select {
    min-width: 200px;
    max-width: 280px;
    width: auto;
    height: 38px;
    font-size: 14px;
    border-radius: 7px;
}

/* Para que el texto de las opciones se vea completo */
.niif-header .filter-select option {
    white-space: normal;
    word-break: break-word;
    padding: 4px 8px;
}

.niif-header .consult-btn {
    height: 38px;
    min-height: 38px;
    padding: 0 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 14px;
    background-color: #6c757d !important;
    color: white !important;
    border: 1px solid #6c757d !important;
    cursor: pointer;
    flex-shrink: 0;
}

.niif-header .consult-btn:hover,
.niif-header .consult-btn:focus,
.niif-header .consult-btn:active,
.niif-header .consult-btn:not(:disabled):hover,
.niif-header .consult-btn:not(:disabled):focus,
.niif-header .consult-btn:not(:disabled):active {
  background-color: #6c757d !important;
  color: white !important;
  border-color: #6c757d !important;
  box-shadow: none !important;
}

.niif-header .consult-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
  background-color: #6c757d !important;
  color: white !important;
  border-color: #6c757d !important;
}

/* Estilos para la flecha y título */
.page-back-btn {
  padding: 0;
  font-size: 1.5rem;
  line-height: 1;
}

.back-icon {
  font-size: 1.75rem !important;
  width: 1.75rem !important;
  height: 1.75rem !important;
}

.param-title {
  font-size: 2rem !important;
  font-weight: 500;
}

.niif-toolbar-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex: 0 0 auto;
}

.table-toolbar-excel-btn {
  height: 31px;
  min-height: 31px;
  padding: 0 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border-radius: 7px;
  font-size: 13px;
  background-color: #016690;
  color: white;
  border: 1px solid #085170;
}

.table-toolbar-excel-btn:hover:not(:disabled) {
  background-color: #085170;
  border-color: #0e3a4d;
}

.table-toolbar-excel-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

/* Ajustes responsivos */
@media (max-width: 1200px) {
  .niif-header .filter-select {
    min-width: 160px;
    max-width: 220px;
    height: 36px;
    font-size: 13px;
  }
  
  .niif-header .consult-btn {
    height: 36px;
    min-height: 36px;
    font-size: 13px;
    padding: 0 16px;
  }
}

@media (max-width: 992px) {
  .niif-header .filters-container {
    flex-wrap: wrap;
    width: 100%;
    margin-top: 8px;
    margin-left: 0 !important;
    justify-content: flex-start;
    gap: 6px;
  }
  
  .niif-header .filter-select {
    min-width: 150px;
    max-width: 200px;
    height: 36px;
    font-size: 13px;
    flex: 1 1 auto;
  }
  
  .niif-header .consult-btn {
    height: 36px;
    min-height: 36px;
    font-size: 13px;
    padding: 0 16px;
  }
}

@media (max-width: 576px) {
  .param-title {
    font-size: 1.5rem !important;
  }
  
  .niif-header .filter-select {
    min-width: 100%;
    max-width: 100%;
    height: 36px;
    font-size: 13px;
    flex: 0 0 100%;
  }
  
  .niif-header .filters-container {
    gap: 4px;
  }
  
  .niif-header .consult-btn {
    width: 100%;
    flex: 0 0 100%;
    height: 36px;
    margin-left: 0 !important;
    margin-top: 4px;
  }
}
</style>